$(function () {
  headerMenus.init();
  categoryMenu.init();
  UserAccount.init();
  ComplexRadio.init();
  lightBox.init();
  initPopovers();
  initTooltips();
  $('.slideshow').find('img:first').on('load', cycleSlideshow.init).each(function(){
    if (this.complete) { $(this).load(); }
  });

  if (navigator.userAgent.match(/msie|trident/i)) {
    $('html').addClass('ie');
  } else if (navigator.userAgent.match(/firefox/i)) {
    $('html').addClass('firefox');
  }

  $('.change-center').change(function () {
    var href = $(this).val();
    if (href) location.href = href;
  });

  var lazyLoadCardImage = $(".card-image.lazy");
  if (lazyLoadCardImage.length) {
    lazyLoadCardImage.lazyload({
      event: "scroll forceLazyLoad",
      effect : "fadeIn"
    });
  }

  var lazyLoadIllustration = $(".lazy-illustration");
  if (lazyLoadIllustration.length) {
    lazyLoadIllustration.lazyload({
      event: "scroll forceLazyLoad",
      effect : "fadeIn"
    });
  }

  var lazyLoadCardLogo = $(".card-logo.lazy-logo");
  if (lazyLoadCardLogo.length) {
    lazyLoadCardLogo.lazyload({
      event: "scroll forceLazyLoad",
      effect : "fadeIn",
      failure_limit : $(lazyLoadCardLogo).length,
      load: function() {
        var img = $(this).data("original");
        var self = $(this);
        RGBaster.colors(img, {
          paletteSize: 10,
          exclude: ['rgb(0,0,0)'],
          success: function(payload) {
            if (payload.dominant == 'rgb(255,255,255)' && payload.secondary == 'rgb(0,0,0)') {
              $(self).closest(".card").addClass('white-logo');
            }
          }
        });
      }
    });
  }

  $('.cards-grid-wrapper-horizontal-scroll-sm-down').on("scroll",function(){
    $("body").trigger("forceLazyLoad");
  });

  $('.avoid-scroll-stealing').on('click', function () {
    $(this).removeClass('avoid-scroll-stealing');
  });

  $("body").trigger("forceLazyLoad");

});

var categoryMenu = {
  init: function () {
    $('.category-navigation-toggler').click(categoryMenu.toggleCategoryNavigation);
  },
  toggleCategoryNavigation: function () {
    $("body").toggleClass("category-navigation-open");
    $(".category-navigation").collapse('toggle');
  }
};

var headerMenus = {
  init: function () {
    var smallScreenIndicator = $(".js-navbar-toggler");
    var navBgTriggerHeight = 56;

    $(document).on('scroll ready', function () {
      var scrollPosition = Math.round($(window).scrollTop()); // round to reduce workload
      if (scrollPosition > navBgTriggerHeight) {
        $('body').addClass('navbar-compact');
      } else {
        $('body').removeClass('navbar-compact');
      }

    });

    if(smallScreenIndicator.is(":hidden")) {
      var body = $('body')

      $(".navbar-custom").hover(
        function(){
          var scrollPosition = $(window).scrollTop();
          if (scrollPosition < navBgTriggerHeight) {
            body.removeClass('navbar-compact')
          }
        }
      );

      var timer;
      var dropdown = $('.dropdown-mega');
      dropdown.on('mouseenter',
        function(){
          clearTimeout(timer);
          var $that = $(this);
          timer = setTimeout(function() {
            $that.addClass('show');
            body.addClass('dropdown-mega-open');
            $that.siblings().removeClass('show');
          }, 300)
        }
      );

      dropdown.on('mouseleave', function() {
        clearTimeout(timer);
        var $that = $(this);
        timer = setTimeout(function() {
          $($that).removeClass('show');
          body.removeClass('dropdown-mega-open')
        }, 300)
      });

    } else {
      $(".expand-sublevel").click(
        function(){
          var navItem = $(this).parent();
          if(navItem.hasClass('show')) {
            navItem.removeClass('show');
            navItem.find('.dropdown-menu').slideUp(300);
          } else {
            navItem.addClass('show');
            navItem.find('.dropdown-menu').hide().slideDown(200);
          }
        }
      );
    }
    $('.js-navbar-toggler').click(headerMenus.toggleMobileNav);

    $('.search-filter-toggler').click(headerMenus.toggleSearchFilter);
  },
  toggleMobileNav: function () {
    event.stopPropagation();
    $("html").toggleClass("prevent-page-vertical-scroll");
    var secondNav = $("#navbarSecond");
    secondNav.toggleClass("show");
  },
  toggleSearchFilter: function () {
    $("html").toggleClass("prevent-page-vertical-scroll");
    $("body").toggleClass("search-filter-open");
    $(".search-filter").toggleClass("show");
  }
};

var UserAccount = {
  init: function () {

    function toggleErrorClass(element, state) {
      element.closest('fieldset').toggleClass("has-error", state)
    }

    $('#user-account').submit(function (event) {
      var password = $('#password');
      toggleErrorClass(password, password.val().length < 8);

      var acceptTerms = $('#acceptTerms');
      toggleErrorClass(acceptTerms, !acceptTerms.checked);

      var mandatoryFields = ["username", "password", "acceptTerms"];
      FormValidation.hasMandatoryValues(mandatoryFields, event)
    });

    $('#user-account-settings').submit(function (event) {
      var existingPassword = $('#existingPassword');
      var newPassword1 = $('#newPassword1');
      var newPassword2 = $('#newPassword2');

      var shouldCheckPasswords = existingPassword.val() != "" || newPassword1.val() != "" || newPassword2.val() != "";
      var passwordTooShort = shouldCheckPasswords && newPassword1.val().length < 8;
      var passwordsDontMatch = shouldCheckPasswords && newPassword1.val() != newPassword2.val();
      toggleErrorClass(existingPassword, shouldCheckPasswords && existingPassword.val().length < 8);
      toggleErrorClass(newPassword1, passwordTooShort || passwordsDontMatch);
      toggleErrorClass(newPassword2, passwordTooShort || passwordsDontMatch);
    })
  }
};

var ComplexRadio = {
  init: function () {
    var radioButtonCheckedOnload = $('.custom-radio-complex .custom-radio input:checked');
    if(radioButtonCheckedOnload.length) {
      radioButtonCheckedOnload.parent().siblings().addClass('muted');
      $('#step-payment .custom-radio-complex .custom-radio').addClass('muted');
      $(this).removeClass('muted');
    }
    $('.custom-radio-complex .custom-radio').on('click', function () {
      $(this).siblings().addClass('muted');
      $(this).removeClass('muted');
    });
    $('#step-payment .custom-radio-complex .custom-radio input[name="paymentMethod"]').on('click', function() {
      $('#step-payment .custom-radio-complex .custom-radio').addClass('muted');
      $(this).removeClass('muted');
    })
  }
};

var lightBox = {
  init: function () {
    var lightboxWrapper = $('.lightbox-wrapper:visible');
    if (lightboxWrapper.length) {
      $(document).bind('keyup', function(e) {
        if (e.which == 27) {
          lightBox.closeLightbox();
        } else if (event.keyCode == 37){
          $('.slideshow').cycle('prev');
        } else if (event.keyCode == 39){
          $('.slideshow').cycle('next');
        }
      });
      var offset = lightboxWrapper.offset();
      lightboxWrapper.css({
        top: offset.top,
        left: offset.left,
        width: this.width,
        height: this.height
      });
      $(document).on('click', 'body:not(.lightbox-open) .lightbox',lightBox.openLightbox);
      $(document).on('click', 'body.lightbox-open .lightbox-wrapper', lightBox.closeLightbox);
    }
  },
  closeLightbox: function() {
    $('.lightbox-wrapper').removeClass('open');
    $('body').removeClass('lightbox-open');
    cycleSlideshow.init();
  },
  openLightbox: function(e) {
    var largeScreen = $(".js-navbar-toggler").is(":hidden");
    if(largeScreen) {
      $('.lightbox-wrapper').addClass('open');
      $('body').addClass('lightbox-open');
      cycleSlideshow.init();
    }
  }
};

var cycleSlideshow = {
  init: function() {
    var cycle = $('.slideshow:visible');
    if (cycle.length) {
      cycle.cycle({
        fx: "fade",
        timeout: 0,
        centerHorz: true,
        swipe : true,
        swipeFx : "scrollHorz",
        autoHeight : "container",
        pager : ".thumbnails-pager",
        pagerTemplate : "<a href='#' class='pager-thumbnail' style='background-image: url(\"{{children.0.src}}\")'></a>",
        log : true
      });
    }
    $('.pager-thumbnail').click(function(event) {
      event.stopPropagation();
    });
    $(window).trigger('resize');
  }
};

var initPopovers = function() {
  $('[data-toggle="popover"]').popover({
    container: 'body',
    trigger: 'hover',
    placement: 'top'
  })
};

var initTooltips = function() {
  $('[data-toggle="tooltip"]').tooltip({
    container: 'body',
    trigger: 'hover',
    placement: 'auto'
  })
};
